<div class="dialog">

  <app-header-dialog [iconName]="'noise_control_off'">
    {{data.title}}
  </app-header-dialog>

  <mat-dialog-content>

    <div class='box'>
      <mat-icon class='dialog-icon'>warning</mat-icon>
      <div class='dialog-text' [innerHTML]='data.message'></div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions fxLayoutAlign="flex-end" justify-content='flex-end'>
    <button mat-raised-button mat-dialog-close="close">
      <mat-icon style='color:gray'>highlight_off</mat-icon>
    </button>
  </mat-dialog-actions>

</div>